export { default as CoreFooterNav } from './Nav';
